import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 34 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.15, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Chapter = ({ num, label, dark = false }) => (
  <FadeUp className="flex items-center gap-4 mb-6">
    <span
      className={`font-mono text-xs tracking-[0.2em] ${dark ? "text-sage" : "text-teal"}`}
      data-testid={`chapter-num-${num}`}
    >
      {num}
    </span>
    <span className={`h-px w-12 ${dark ? "bg-sage/50" : "bg-teal/40"}`} />
    <span
      className={`text-xs uppercase tracking-[0.28em] font-semibold ${dark ? "text-sage" : "text-teal"}`}
    >
      {label}
    </span>
  </FadeUp>
);

export const DemiCercle = ({ className = "" }) => (
  <div className={`rounded-t-full ${className}`} aria-hidden="true" />
);
